import * as C from '../common/constants';
import * as THREE from 'three';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { Circle, Environment, Lightformer } from '@react-three/drei';
import { useSelector, useDispatch } from 'react-redux';

// apartment: 'lebombo_1k.hdr',
// city: 'potsdamer_platz_1k.hdr',
// dawn: 'kiara_1_dawn_1k.hdr',
// forest: 'forest_slope_1k.hdr',
// lobby: 'st_fagans_interior_1k.hdr',
// night: 'dikhololo_night_1k.hdr',
// park: 'rooitou_park_1k.hdr',
// studio: 'studio_small_03_1k.hdr',
// sunset: 'venice_sunset_1k.hdr',
// warehouse: 'empty_warehouse_01_1k.hdr',

const Background = () => {
  const isPlatformVisible = useSelector(
    (state: any) => state.app[C.SET_PLATFORM]
  );

  const isSkyVisible = useSelector((state: any) => state.app[C.SET_SKY]);

  if (isSkyVisible) {
    return <Environment files="./assets/sky.hdr" background />;
  }

  const bgColor = new THREE.Color(COLORS.nBg);

  return (
    <>
      <color attach="background" args={[bgColor.r, bgColor.g, bgColor.b]} />
      <Environment
        files="./assets/empty_warehouse_01_1k.hdr"
        background={false}
        // preset={'city'}
      >
        {/* <Lightformer
          form="rect" // circle | ring | rect (optional, default = rect)
          intensity={1} // power level (optional = 1)
          color="white" // (optional = white)
          // scale={[10, 5]} // Scale it any way you prefer (optional = [1, 1])
          target={[0, 0, 0]} // Target position (optional = undefined)
        /> */}
      </Environment>
      {/* <Circle
        position={[0, -1.09, 0]}
        args={[4.5, 300]}
        rotation-x={-Math.PI / 2 - 0.01}
        receiveShadow
      >
        <meshStandardMaterial color={COLORS.nPodium} />
      </Circle> */}
    </>
  );
};

export default Background;
